import type { ComponentRegistry } from '@vibesites/runtime';
import {
  Header,
  Hero,
  PropertyOverview,
  ScrollableGallery,
  LayoutOverview,
  SpecialOffers,
  CTASection,
  GalleryOverview,
  FloorplansList,
  CommunityAmenitiesList,
  InteriorAmenitiesList,
  PetsCallout,
  Gallery,
  NeighborhoodMap,
  VirtualTourEmbed,
  ContactForm,
  ContactMap,
  ScheduleTourForm,
  Fees,
  PetPolicy,
  PageHero,
  PageBlurb,
  HeroSolidBG,
  Reviews,
  ReviewsCarousel,
  ReviewsCallout,
  GalleryHomeBlurb,
  SocialFollow,
  SpecialOfferBanner,
  ResidentAccess,
  ApplyNow,
  AccessibilityStatement,
  PrivacyPolicyContent,
  SitemapContent,
  HyperlocalHero,
  HyperlocalPageCopy,
  ThankYouContent,
  FutureResidentsClub,
  ApartmentSyncSection,
  Footer,
  Navigation,
  InteractiveMapSection,
  InstagramSection,
} from './components';

export const registry: ComponentRegistry = {
  Header,
  Hero,
  PropertyOverview,
  ScrollableGallery,
  LayoutOverview,
  SpecialOffers,
  CTASection,
  GalleryOverview,
  FloorplansList,
  CommunityAmenitiesList,
  InteriorAmenitiesList,
  PetsCallout,
  Gallery,
  NeighborhoodMap,
  VirtualTourEmbed,
  ContactForm,
  ContactMap,
  ScheduleTourForm,
  Fees,
  PetPolicy,
  PageHero,
  PageBlurb,
  HeroSolidBG,
  Reviews,
  ReviewsCarousel,
  ReviewsCallout,
  GalleryHomeBlurb,
  SocialFollow,
  SpecialOfferBanner,
  ResidentAccess,
  ApplyNow,
  AccessibilityStatement,
  PrivacyPolicyContent,
  SitemapContent,
  HyperlocalHero,
  HyperlocalPageCopy,
  ThankYouContent,
  FutureResidentsClub,
  ApartmentSyncSection,
  Footer,
  Navigation,
  InteractiveMapSection,
  InstagramSection,
};

export default registry;
